function isBackward(selection) {
  var startNode = selection.anchorNode;
  var startOffset = selection.anchorOffset;
  var endNode = selection.focusNode;
  var endOffset = selection.focusOffset;
  var position = startNode.compareDocumentPosition(endNode);
  return !(position === 4 || position === 0 && startOffset < endOffset);
}

module.exports = isBackward;